export default __webpack_public_path__ + "static/media/pie_placeholder.c4cb0f6b.png";